import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAllLiteracyBadges extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LiteracyBadges/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class CreateALiteracyBadge extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LiteracyBadges/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UpdateALiteracyBadge extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LiteracyBadges/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteALiteracyBadge extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LiteracyBadges/Delete");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetALiteracyBadge extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LiteracyBadges/Get");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  GetAllLiteracyBadges,
  CreateALiteracyBadge,
  UpdateALiteracyBadge,
  DeleteALiteracyBadge,
  GetALiteracyBadge,
};
